import type React from 'react';

export interface DetailSectionProps {
  id: string;
  label: string;
  count?: number;
  /** Child component already renders its own PageSection heading. */
  hasOwnShell?: boolean;
  children: React.ReactNode;
}

/** Declarative section contract; route fallback uses the same content. */
export default function DetailSection({ children }: DetailSectionProps) {
  return children;
}
